import { Button, Dialog, IconButton } from '@material-ui/core';
import variables from '../../../utils/variables';
import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './index.css';
import { ReactComponent as VideoIcon } from '../../../assets/create/new_video.svg';
import { ReactComponent as AudioIcon } from '../../../assets/create/new_audio.svg';
import { ReactComponent as ImageIcon } from '../../../assets/create/new_image.svg';
import deleteIcon from '../../../assets/create/new_delete.svg';
import cancelIcon from '../../../assets/create/cancel.svg';
import successIcon from '../../../assets/create/success.svg';
import redoIcon from '../../../assets/create/redo.svg';
import viewIcon from '../../../assets/create/new_view.svg';
import spinnerIcon from '../../../assets/create/spinner.svg';
import { showMessage } from '../../../actions/snackbar';
import {
    deleteAsset,
    fetchAsset,
    fetchAssetCards,
    hideUploadFilesDialog,
    setAssetUpload,
    setBulkMint,
    setCancelUpload,
    showPreviewDialog,
    uploadAsset,
} from '../../../actions/createAssets';
import { fetchAssets, setLibraryTabValue } from '../../../actions/library';
import { getAssetType } from '../../../utils/strings';
import LinearProgressWithLabel from '../../../components/LinearProgressWithLabel';
import withRouter from '../../../components/WithRouter';
import { DEFAULT_LIMIT, DEFAULT_SKIP, DEFAULT_UPLOAD_LIMIT_RUNNER, TRANSACTION_SET_TIME_OUT } from '../../../config';
import closeIcon from '../../../assets/interactive/close.svg';
import { ReactComponent as InteractiveVideos } from '../../../assets/sideBar/interactive.svg';

class UploadFilesDialog extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            count: 0,
            activeTab: 'All',
            deletedItems: [],
        };

        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleActiveTab = this.handleActiveTab.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleMint = this.handleMint.bind(this);
        // this.handleDeleteFromPreview = this.handleDeleteFromPreview.bind(this);
        this.handleReFetchAssets = this.handleReFetchAssets.bind(this);
        this.handleContractPublish = this.handleContractPublish.bind(this);
    }

    handleFileChange (selectedFiles, list, index) {
        const uploadList = [...list];
        const length = Object.keys(selectedFiles) && Object.keys(selectedFiles).length;
        if (length > index && Object.keys(selectedFiles) && Object.keys(selectedFiles)[index]) {
            const val = Object.keys(selectedFiles)[index];
            const obj = selectedFiles[val];
            const type = obj && obj.type && getAssetType(obj.type);
            const fileSize = obj.size;
            if (['video', 'audio', 'image', 'document'].indexOf(type) === -1) {
                this.props.showMessage('File format not supported', 'warning');
                return null;
            }

            if (fileSize > DEFAULT_UPLOAD_LIMIT_RUNNER) {
                this.props.showMessage(variables[this.props.lang].file_size_exceeded_4gb, 'warning');
                this.handleFileChange(selectedFiles, uploadList, index + 1);
                return;
            }

            if (obj) {
                const id = 'uploadId' + Math.random().toString(16).slice(2);
                uploadList.push({
                    id,
                    file: obj,
                });

                this.props.setAssetUpload(obj, [...uploadList]);
                this.props.uploadAsset(this.props.profileDetails._id, obj, id, (error, result) => {
                    if (!error) {
                        const itemIndex = uploadList.findIndex((item) => item.id === id);
                        if (itemIndex > -1 && uploadList[itemIndex] && result && result._id) {
                            uploadList[itemIndex]._id = result._id;
                        }
                        this.handleFileChange(selectedFiles, uploadList, index + 1);
                    } else {
                        this.handleCancel(id);
                        this.handleFileChange(selectedFiles, uploadList, index + 1);
                    }
                });
            } else {
                this.props.showMessage('File Not Selected', 'warning');
            }
        } else {
            this.setState({
                count: this.props.assets && this.props.assets.length,
            });

            this.props.fetchAssets(DEFAULT_SKIP, DEFAULT_LIMIT, (result, count) => {
                if (this.props.assetsTotal === count) {
                    setTimeout(() => {
                        this.props.fetchAssets(DEFAULT_SKIP, DEFAULT_LIMIT);
                    }, TRANSACTION_SET_TIME_OUT);
                } else {
                    setTimeout(() => {
                        this.handleReFetchAssets(uploadList);
                    }, 5000);
                }
            });
        }
    }

    handleReFetchAssets (uploadList) {
        let fetch = true;
        if (uploadList && uploadList.length) {
            this.props.fetchAssets(DEFAULT_SKIP, DEFAULT_LIMIT, (result) => {
                uploadList.map((val) => {
                    const find = val && val._id && result && result.find((item) => item._id === val._id);
                    if (find && find.file && find.file.status && find.file.status === 'PROCESSING' && fetch) {
                        fetch = false;
                        setTimeout(() => {
                            this.handleReFetchAssets(uploadList);
                        }, 5000);
                    }
                });
            });
        }
    }

    handleCancel (id) {
        let uploadList = [...this.props.uploadList];
        const obj = uploadList.find((val) => val.id === id);
        obj.cancel = true;
        uploadList = uploadList.map((val) => val.id !== obj.id ? val : obj);

        this.props.setCancelUpload([...uploadList]);
        const cancel = this.props.uploadAssetCancel && this.props.uploadAssetCancel[id];
        if (cancel) {
            cancel();
        }
    }

    handleRedirect () {
        if (this.props.tabValue !== 'non-minted') {
            this.props.setLibraryTabValue('non-minted');
        }

        this.props.handleClose();
        this.props.setAssetUpload(null, []);
        if (this.props.assets && this.state.count === this.props.assets.length && !this.props.assetsInProgress) {
            this.props.fetchAssets(DEFAULT_SKIP, DEFAULT_LIMIT);
        }
        this.props.router.navigate('/library');
    }

    handleClose () {
        this.props.handleClose();
        this.props.setAssetUpload(null, []);

        if (this.props.assets && this.state.count === this.props.assets.length && !this.props.assetsInProgress) {
            this.props.fetchAssets(DEFAULT_SKIP, DEFAULT_LIMIT);
        }
        this.props.fetchAssetCards();
    }

    handleActiveTab (value) {
        this.setState({
            activeTab: value,
        });
    }

    handleRetry (id) {
        const uploadList = [...this.props.uploadList];
        const failedItem = uploadList.find((item) => item.id === id);

        if (failedItem) {
            failedItem.cancel = false;
            this.props.setCancelUpload([...uploadList]);
            this.props.uploadAsset(this.props.profileDetails._id, failedItem.file, id, (error) => {
                if (error) {
                    this.handleCancel(id);
                }
            });
        }
    }

    handleDelete (item) {
        this.props.deleteAsset(item && item._id, (error) => {
            if (!error) {
                this.setState((prevState) => ({
                    deletedItems: [...prevState.deletedItems, item._id],
                }));
                this.props.fetchAssets(DEFAULT_SKIP, DEFAULT_LIMIT);
            }
        });
    }

    handleMint (item) {
        if (item && item._id) {
            this.handleRedirect();
            this.props.setBulkMint(true);
            this.props.fetchAsset(item._id);
            this.props.router.navigate('/library');
            this.props.setLibraryTabValue('non-minted');
            this.handleClose();
        } else {
            this.props.showMessage('Something went wrong, try again', 'warning');
        }
    }

    handleContractPublish (event, value) {
        event.stopPropagation();
        this.handleClose();
        this.props.router.navigate(`/asset/${value?._id}/publish`);
    }

    render () {
        const successfulUploads = this.props.uploadList.filter((item) => {
            const uploadProgress = this.props.uploadProgress.find((val) => val.id === item.id);
            return !item.cancel && !this.state.deletedItems.includes(item._id) &&
                uploadProgress && uploadProgress.progress &&
                uploadProgress.progress.loaded === uploadProgress.progress.total;
        }).length;

        const failedUploads = this.props.uploadList.filter((item) => item.cancel).length;
        return (
            <Dialog
                aria-describedby="preview-dialog-description"
                aria-labelledby="preview-dialog-title"
                className="upload_files_dialog"
                open={this.props.open}
                onClose={this.handleClose}>
                <div>
                    {variables[this.props.lang]['select_the_source']}
                    <IconButton onClick={this.handleClose}>
                        <img alt="closeIcon" src={closeIcon}/>
                    </IconButton>
                </div>
                <div>
                    <div>
                        <div
                            className="upload_files" onDragOver={(event) => event.preventDefault()}
                            onDrop={(e) => {
                                e.preventDefault();
                                this.handleFileChange(e.dataTransfer.files, this.props.uploadList, 0);
                            }}>
                            <div>{variables[this.props.lang]['drag_and_drop']}</div>
                            <div>{variables[this.props.lang].dashed_or}</div>
                            <Button>
                                {variables[this.props.lang]['browse_files']}
                                <input
                                    multiple
                                    type="file"
                                    onChange={(e) =>
                                        this.handleFileChange(e.target.files, this.props.uploadList, 0)
                                    }/>
                            </Button>
                            <div>
                                <p>{variables[this.props.lang]['supported_formats']}</p>
                                <span>{variables[this.props.lang]['drop_an_asset_size_up_to_2GB']}</span>
                            </div>
                        </div>
                        <p>{variables[this.props.lang].check_the_uploaded_files}</p>
                        <Button aria-label="go-to-library" onClick={this.handleRedirect}>
                            <div>
                                {variables[this.props.lang]['go_to_asset_library']}
                            </div>
                        </Button>
                    </div>
                    {this.props.uploadList && this.props.uploadList.length
                        ? <div className="files_list">
                            <div className="header">
                                <span
                                    className={this.state.activeTab === 'All' ? 'active' : ''}
                                    onClick={() => this.handleActiveTab('All')}>{variables[this.props.lang].all}</span>
                                <span
                                    className={this.state.activeTab === 'Uploaded' ? 'active' : ''}
                                    onClick={() => this.handleActiveTab('Uploaded')}>{variables[this.props.lang].uploaded} ({successfulUploads}) </span>
                                <span
                                    className={this.state.activeTab === 'Failed' ? 'active' : ''}
                                    onClick={() => this.handleActiveTab('Failed')}>{variables[this.props.lang].failed} ({failedUploads}) </span>
                            </div>
                            {this.state.activeTab === 'All' && this.props.uploadList.map((item) => {
                                if (this.state.deletedItems.includes(item._id)) {
                                    return null;
                                }
                                const uploadProgress = this.props.uploadProgress && this.props.uploadProgress.length &&
                                    this.props.uploadProgress.find((val) => val.id === item.id);
                                const assetType = getAssetType(item.file?.type);
                                const matchingAsset = this.props.assets.find((asset) => asset._id === item._id);
                                let uploadSuccess;
                                const type = matchingAsset && matchingAsset.file && matchingAsset.file.MIME_type && getAssetType(matchingAsset.file['MIME_type']);
                                if (this.props.successList && this.props.successList.length &&
                                    this.props.successList.indexOf(item.id) > -1) {
                                    uploadSuccess = true;
                                }
                                return (
                                    <div key={item.id} className="file_details">
                                        <div className="file_name">
                                            {assetType && (assetType === 'video' ? <VideoIcon/>
                                                : assetType === 'audio' ? <AudioIcon/>
                                                    : assetType === 'image' ? <ImageIcon/> : null)}
                                            <span>{item.file.name}</span>
                                            {((uploadProgress && uploadProgress.progress && uploadProgress.progress.total &&
                                                    uploadProgress.progress.loaded && (uploadProgress.progress.loaded === uploadProgress.progress.total)) ||
                                                uploadSuccess) &&
                                            !item.cancel && matchingAsset && matchingAsset.file && matchingAsset.file.status === 'COMPLETE'
                                                ? <>
                                                    <span className="dot"/>
                                                    <IconButton
                                                        onClick={() => this.props.showPreviewDialog(matchingAsset)}>
                                                        <img alt="view" src={viewIcon}/>
                                                    </IconButton>
                                                </>
                                                : null}
                                        </div>
                                        {item.cancel
                                            ? <div className="file_status">
                                                <span className="failed_status status_text">
                                                    {variables[this.props.lang]['upload_failed']}
                                                </span>
                                                <Button
                                                    startIcon={<img alt="redo_icon" src={redoIcon}/>}
                                                    onClick={() => this.handleRetry(item.id)}>
                                                    {variables[this.props.lang].retry}
                                                </Button>
                                            </div>
                                            : ((uploadProgress && uploadProgress.progress && uploadProgress.progress.total &&
                                            uploadProgress.progress.loaded && (uploadProgress.progress.loaded === uploadProgress.progress.total)) ||
                                                uploadSuccess) &&
                                            !matchingAsset
                                                ? <div className="file_status">
                                                    <img alt="icon" height="12" src={successIcon} width="16"/>
                                                    <span
                                                        className="success_status status_text">
                                                        {variables[this.props.lang]['asset_uploaded_successfully']}
                                                    </span>
                                                </div>
                                                : ((uploadProgress && uploadProgress.progress && uploadProgress.progress.total &&
                                                uploadProgress.progress.loaded && (uploadProgress.progress.loaded === uploadProgress.progress.total)) ||
                                                    uploadSuccess)
                                                    ? <div className="file_status success_status">
                                                        {type === 'video' && matchingAsset?.file?.status && matchingAsset.file.status === 'COMPLETE'
                                                            ? <Button className="publish_button" onClick={(event) => this.handleContractPublish(event, matchingAsset)}>
                                                                <InteractiveVideos/>
                                                                {variables[this.props.lang].publish}
                                                            </Button>
                                                            : null}
                                                        {matchingAsset && matchingAsset.file && matchingAsset.file.status === 'COMPLETE'
                                                            ? <Button className="mint_button" onClick={() => this.handleMint(item)}>
                                                                {variables[this.props.lang].mint}
                                                            </Button>
                                                            : <div>
                                                                <img
                                                                    alt="icon" height={20} src={spinnerIcon}
                                                                    width={20}/>
                                                                <p>{variables[this.props.lang].processing + '...'}</p>
                                                            </div>}
                                                        <IconButton onClick={() => this.handleDelete(item)}>
                                                            <img alt="deleteIcon" src={deleteIcon}/>
                                                        </IconButton>
                                                    </div>
                                                    : uploadProgress && uploadProgress.progress && uploadProgress.progress.total &&
                                                    uploadProgress.progress.loaded
                                                        ? <div className="upload_status">
                                                            <div className="linear_progress">
                                                                <LinearProgressWithLabel
                                                                    noText={true}
                                                                    value={((uploadProgress.progress.loaded / uploadProgress.progress.total) * 100).toFixed(0)}/>
                                                            </div>
                                                            <img
                                                                alt="icon" src={cancelIcon}
                                                                onClick={() => this.handleCancel(item.id)}/>
                                                        </div>
                                                        : <div className="upload_status">
                                                            <div className="linear_progress in_queue">
                                                                <span>{variables[this.props.lang].upload_in_queue}</span>
                                                            </div>
                                                            <img
                                                                alt="icon" src={cancelIcon}
                                                                onClick={() => this.handleCancel(item.id)}/>
                                                        </div>}
                                    </div>
                                );
                            })}
                            {this.state.activeTab === 'Uploaded' && this.props.uploadList.map((item) => {
                                if (this.state.deletedItems.includes(item._id)) {
                                    return null;
                                }
                                const uploadProgress = this.props.uploadProgress && this.props.uploadProgress.length &&
                                    this.props.uploadProgress.find((val) => val.id === item.id);
                                const assetType = getAssetType(item.file?.type);
                                const matchingAsset = this.props.assets.find((asset) => asset._id === item._id);
                                const type = matchingAsset && matchingAsset.file && matchingAsset.file.MIME_type && getAssetType(matchingAsset.file['MIME_type']);
                                return !item.cancel && uploadProgress && uploadProgress.progress && uploadProgress.progress.total &&
                                uploadProgress.progress.loaded && (uploadProgress.progress.loaded === uploadProgress.progress.total) ? (
                                        <div key={item.id} className="file_details">
                                            <div className="file_name">
                                                {assetType && (assetType === 'video' ? <VideoIcon/>
                                                    : assetType === 'audio' ? <AudioIcon/>
                                                        : assetType === 'image' ? <ImageIcon/> : null)}
                                                <span>{item.file.name}</span>
                                                {matchingAsset && matchingAsset.file && matchingAsset.file.status === 'COMPLETE'
                                                    ? <>
                                                        <span className="dot"/>
                                                        <IconButton
                                                            onClick={() => this.props.showPreviewDialog(matchingAsset)}>
                                                            <img alt="view" src={viewIcon}/>
                                                        </IconButton>
                                                    </>
                                                    : null}
                                            </div>
                                            <div className="file_status success_status">
                                                {type === 'video' && matchingAsset?.file?.status && matchingAsset.file.status === 'COMPLETE'
                                                    ? <Button className="publish_button" onClick={(event) => this.handleContractPublish(event, matchingAsset)}>
                                                        <InteractiveVideos/>
                                                        {variables[this.props.lang].publish}
                                                    </Button>
                                                    : null}
                                                {matchingAsset && matchingAsset.file && matchingAsset.file.status === 'COMPLETE'
                                                    ? <Button className="mint_button" onClick={() => this.handleMint(item)}>
                                                        {variables[this.props.lang].mint}
                                                    </Button>
                                                    : <div>
                                                        <img alt="icon" height={20} src={spinnerIcon} width={20}/>
                                                        <p>{variables[this.props.lang].processing + '...'}</p>
                                                    </div>}
                                                <IconButton onClick={() => this.handleDelete(item)}>
                                                    <img alt="deleteIcon" src={deleteIcon}/>
                                                </IconButton>
                                            </div>
                                        </div>
                                    ) : null;
                            })}
                            {this.state.activeTab === 'Failed' && this.props.uploadList.map((item) => {
                                const assetType = getAssetType(item.file?.type);
                                return !item.cancel ? null : (
                                    <div key={item.id} className="file_details">
                                        <div className="file_name">
                                            {assetType && (assetType === 'video' ? <VideoIcon/>
                                                : assetType === 'audio' ? <AudioIcon/>
                                                    : assetType === 'image' ? <ImageIcon/> : null)}
                                            <span>{item.file.name}</span>
                                        </div>
                                        <div className="file_status">
                                            <span className="failed_status status_text">
                                                {variables[this.props.lang]['upload_failed']}
                                            </span>
                                            <Button
                                                startIcon={<img alt="redo_icon" src={redoIcon}/>}
                                                onClick={() => this.handleRetry(item.id)}>
                                                {variables[this.props.lang].retry}
                                            </Button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div> : null}
                </div>
            </Dialog>
        );
    }
}

UploadFilesDialog.propTypes = {
    assets: PropTypes.array.isRequired,
    assetsInProgress: PropTypes.bool.isRequired,
    deleteAsset: PropTypes.func.isRequired,
    fetchAsset: PropTypes.func.isRequired,
    fetchAssetCards: PropTypes.func.isRequired,
    fetchAssets: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    profileDetails: PropTypes.object.isRequired,
    setAssetUpload: PropTypes.func.isRequired,
    setBulkMint: PropTypes.func.isRequired,
    setCancelUpload: PropTypes.func.isRequired,
    setLibraryTabValue: PropTypes.func.isRequired,
    showMessage: PropTypes.func.isRequired,
    showPreviewDialog: PropTypes.func.isRequired,
    uploadAsset: PropTypes.func.isRequired,
    uploadAssetCancel: PropTypes.object.isRequired,
    uploadList: PropTypes.array.isRequired,
    uploadProgress: PropTypes.array.isRequired,
    assetsLimit: PropTypes.number,
    assetsSkip: PropTypes.number,
    assetsTotal: PropTypes.number,
    router: PropTypes.shape({
        navigate: PropTypes.func.isRequired,
    }),
    successList: PropTypes.array,
    tabValue: PropTypes.string,
};

const stateToProps = (state) => {
    return {
        assets: state.library.assets.value,
        assetsInProgress: state.library.assets.inProgress,
        assetsSkip: state.library.assets.skip,
        assetsLimit: state.library.assets.limit,
        assetsTotal: state.library.assets.total,
        open: state.createAssets.new.uploadFilesDialog,
        lang: state.language,
        profileDetails: state.account.profileDetails.value,
        uploadList: state.createAssets.new.uploadAsset.list,
        uploadProgress: state.createAssets.new.uploadAsset.progress,
        uploadAssetCancel: state.createAssets.new.uploadAsset.cancel,
        successList: state.createAssets.new.uploadAsset.successList,
        tabValue: state.library.libraryTabValue,
    };
};

const actionToProps = {
    handleClose: hideUploadFilesDialog,
    setAssetUpload,
    setCancelUpload,
    setLibraryTabValue,
    showMessage,
    uploadAsset,
    deleteAsset,
    fetchAssets,
    fetchAsset,
    setBulkMint,
    showPreviewDialog,
    fetchAssetCards,
};

export default withRouter(connect(stateToProps, actionToProps)(UploadFilesDialog));
